_ = require("lodash")

FriendService = ($http, $q) ->
  addFriend: (friend) ->
    $http.post "/api/players.json",
      name: friend.name
      player_hdcp: friend.player_hdcp
      email: friend.email

  removeFriend: (friend) ->
    $http.put "/api/players/#{friend.id}.json",
      display_as_friend: "0"

  updateFriend: (friend) ->
    $http.put "/api/players/#{friend.id}.json",
      name: friend.name
      player_hdcp: friend.player_hdcp
      email: friend.email

  getFriends: (options) ->
    url = "/api/players.json"
    delay = $q.defer()
    params = _.pickBy options, (v) -> v != null && v != undefined

    $http.get(url, params: params).then (resp) ->
      resp.data.players = _.forEach resp.data.players, (f) ->
        f.restore = -> _.merge f, f._cache
        f.isDataChanged = ->
          f.name isnt f._cache.name or
            f.email isnt f._cache.email or
            f.player_hdcp isnt f._cache.player_hdcp
        f.setCache = -> f._cache = _.pick f, 'name', 'player_hdcp', 'email'
        f.setCache()

      delay.resolve resp.data
    delay.promise

FriendService.$inject = [
  '$http'
  '$q'
]

module.exports = FriendService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/friend/friend-service.coffee